import { jsx as _jsx } from "react/jsx-runtime";
import { Loading } from "@bluframe/blublocks";
import { NewsItem } from "@bluframe/mightychroma-mightytool-ui";
const Item = ({ loading, ...props }) => loading || !props.item ? (_jsx(Loading, {})) : (_jsx(NewsItem, { ...props, item: props.item }));
export default Item;
